import React from "react";
import _ from "lodash";

import AllModal from "../components/AllModal";
import AllStart from "../components/AllStart";

const ChooseAsker = ({
  roomId,
  ttl_lie,
  playerId,
  mobile_app,
  ttl_truths,
  toggleModal,
  set_ttl_lie,
  set_ttl_truths,
  ttl_modal_open,
  chooseasker_params,
}) => {
  const modal_title = _.get(
    chooseasker_params,
    "modal_title",
    "The Host is picking The Player",
  );

  return !ttl_modal_open ? (
    <AllStart
      mobile_app={mobile_app}
      toggleModal={toggleModal}
      chooseasker_params={chooseasker_params}
    />
  ) : (
    <AllModal
      roomId={roomId}
      ttl_lie={ttl_lie}
      playerId={playerId}
      mobile_app={mobile_app}
      ttl_truths={ttl_truths}
      toggleModal={toggleModal}
      set_ttl_lie={set_ttl_lie}
      modal_title={modal_title}
      set_ttl_truths={set_ttl_truths}
    />
  );
};

export default ChooseAsker;
